module.exports = __webpack_public_path__ + "img/image11.0e7541ff.webp";